<button
  mat-raised-button
  class="button-secondary"
  [ngClass]="btnClass"
  (click)="onClick()"
>
  {{ btnTitle }}
</button>
